import "./styles/tokens.css";
import "./styles/base.css";
import "./styles/layout.css";
import "./styles/components.css";

import { route, startRouter } from "./lib/router";
import {
  pageHome,
  pageAbout,
  pageHorse,
  pageMembership,
  pageFaq,
  pageContact,
  pageJoin,
  pagePrivacy,
  pageTerms,
  pageNotFound,
  pageComplaints,
} from "./pages/public";
import {
  pageMembersLogin,
  pageMembersDashboard,
  pageMembersHorse,
  pageMembersDiary,
  pageMembersDocuments,
  pageMembersBallot,
  pageMembersPrize,
} from "./pages/members";
import {
  pageAdminLogin,
  pageAdminOverview,
  pageAdminMembers,
  pageAdminUpdates,
  pageAdminCalendar,
  pageAdminFinance,
} from "./pages/admin";

route("/", pageHome);
route("/about", pageAbout);
route("/horse", pageHorse);
route("/membership", pageMembership);
route("/faq", pageFaq);
route("/contact", pageContact);
route("/join", pageJoin);
route("/privacy", pagePrivacy);
route("/terms", pageTerms);
route("/complaints", pageComplaints);

route("/members/login", pageMembersLogin);
route("/members", pageMembersDashboard);
route("/members/prize", pageMembersPrize);
route("/members/horse", pageMembersHorse);
route("/members/diary", pageMembersDiary);
route("/members/documents", pageMembersDocuments);
route("/members/ballot", pageMembersBallot);

route("/admin/login", pageAdminLogin);
route("/admin", pageAdminOverview);
route("/admin/members", pageAdminMembers);
route("/admin/updates", pageAdminUpdates);
route("/admin/calendar", pageAdminCalendar);
route("/admin/finance", pageAdminFinance);

route("*", pageNotFound);

startRouter();
